export interface TerminalAdyen {
  tipo: string;
  numero: string;
  loja: string;
}

// Terminais cadastrados na Adyen. Estava duplicado em abrir-atendimento e dashboard, que é
// como a regra de parcelamento acabou divergindo entre os dois fluxos de pagamento.
export const TERMINAIS_ADYEN: TerminalAdyen[] = [
  { tipo: 'V240mPlus', numero: '542104953', loja: 'Fatima' },
  { tipo: 'V240mPlus', numero: '542104531', loja: 'Centro' },
  { tipo: 'V240mPlus', numero: '542105038', loja: 'Messejana II' },
  { tipo: 'V240mPlus', numero: '542104714', loja: 'Via Sul' },
  { tipo: 'P400Plus', numero: '806613539', loja: 'Centro' },
  { tipo: 'P400Plus', numero: '806613540', loja: 'Fatima' },
  { tipo: 'V240mPlus', numero: '542104952', loja: 'Fatima' },
  { tipo: 'V240mPlus', numero: '542104951', loja: 'Fatima' },
  { tipo: 'V240mPlus', numero: '542104715', loja: 'Via Sul' },
  { tipo: 'V240mPlus', numero: '542104530', loja: 'Centro' },
  { tipo: 'V240mPlus', numero: '542105037', loja: 'Messejana II' },
  { tipo: 'V240mPlus', numero: '542104713', loja: 'Via Sul' },
  { tipo: 'V240mPlus', numero: '542105036', loja: 'Messejana II' },
  { tipo: 'V240mPlus', numero: '542104529', loja: 'Centro' },
  { tipo: 'P400Plus', numero: '806613541', loja: 'Messejana II' },
  { tipo: 'P400Plus', numero: '806613542', loja: 'Via Sul' },
  { tipo: 'S1F2', numero: '000158253980426', loja: 'Rua Grande' },
];

export const TIPO_TERMINAL_S1F2 = 'S1F2';

// O serial do S1F2 na Adyen tem três zeros à frente que não aparecem no aparelho. Sem eles
// pré-preenchidos o operador digita o que lê no equipamento e monta um POIID que não existe.
export const PREFIXO_SERIAL_S1F2 = '000';

/** Serial inicial do campo ao escolher o tipo de terminal. */
export function serialInicialPorTipo(tipo: string): string {
  return tipo === TIPO_TERMINAL_S1F2 ? PREFIXO_SERIAL_S1F2 : '';
}

export function filtrarTerminaisPorTipo(tipo: string, termo: string, limite = 8): TerminalAdyen[] {
  const busca = (termo ?? '').trim();
  return TERMINAIS_ADYEN
    .filter(t => t.tipo === tipo && (busca.length === 0 || t.numero.includes(busca)))
    .slice(0, limite);
}

/** POIID enviado para a Adyen. Só existe com tipo e serial preenchidos. */
export function montarTerminalFull(tipo: string, termo: string): string {
  const busca = (termo ?? '').trim();
  if (!tipo || busca.length === 0) return '';
  // Só o prefixo pré-preenchido não é serial: não pode habilitar o envio.
  if (tipo === TIPO_TERMINAL_S1F2 && busca === PREFIXO_SERIAL_S1F2) return '';
  return `${tipo}-${busca}`;
}

/**
 * Modelo pelo serial, para o operador digitar só o número (o POIID é modelo-serial).
 * Primeiro a lista cadastrada; senão o formato: S1F2 tem 15 dígitos com 000 na frente,
 * V240mPlus começa com 542 e P400Plus com 806.
 */
export function modeloPorSerial(serial: string): string {
  const s = (serial ?? '').replace(/\D/g, '');
  const cadastrado = TERMINAIS_ADYEN.find(t => t.numero === s);
  if (cadastrado) return cadastrado.tipo;
  if (s.length === 15 && s.startsWith(PREFIXO_SERIAL_S1F2)) return TIPO_TERMINAL_S1F2;
  if (s.length === 9 && s.startsWith('542')) return 'V240mPlus';
  if (s.length === 9 && s.startsWith('806')) return 'P400Plus';
  return '';
}

/** POIID a partir só do serial; vazio quando o modelo não dá para deduzir. */
export function poiidPorSerial(serial: string): string {
  const s = (serial ?? '').replace(/\D/g, '');
  const modelo = modeloPorSerial(s);
  return modelo ? montarTerminalFull(modelo, s) : '';
}

export interface SerialEmCache { serial: string; usadoEm: string; modelo?: string; }

const CHAVE_CACHE = (guiche: string) => `sim:maq:${guiche || 'sem-guiche'}`;

/** Até 3 seriais por guichê, o mais recente primeiro. localStorage pode falhar: vira lista vazia. */
export function lerCacheSeriais(guiche: string): SerialEmCache[] {
  try {
    const lista = JSON.parse(localStorage.getItem(CHAVE_CACHE(guiche)) ?? '[]');
    return Array.isArray(lista) ? lista.slice(0, 3) : [];
  } catch {
    return [];
  }
}

export function lembrarSerial(guiche: string, serial: string, modelo = ''): SerialEmCache[] {
  const s = (serial ?? '').replace(/\D/g, '');
  const novo: SerialEmCache = { serial: s, usadoEm: new Date().toISOString(), ...(modelo ? { modelo } : {}) };
  const lista = [novo, ...lerCacheSeriais(guiche).filter(c => c.serial !== s)].slice(0, 3);
  try { localStorage.setItem(CHAVE_CACHE(guiche), JSON.stringify(lista)); } catch { /* segue sem cache */ }
  return lista;
}

export function limparCacheSeriais(guiche: string): void {
  try { localStorage.removeItem(CHAVE_CACHE(guiche)); } catch { /* nada a limpar */ }
}
